document.addEventListener("DOMContentLoaded", () => {
  const promoBar = document.querySelector(".announcement__text"); 

  if (promoBar) {
     const promoBarLink = promoBar.querySelectorAll("a");

     promoBarLink.forEach(link => {
    link.addEventListener("click", () => {
      const parentPromo = link.closest("[id]"); // find slide with ID
        const promoId = parentPromo ? parentPromo.id : "unknown";

      const eventData = {
        promo_id: promoId,
        promo_text: link.innerText.trim(),
        promo_url: link.getAttribute("href")
      };

      console.log("promo bar clicked", eventData);

      // Publish to Shopify analytics pipeline
      Shopify.analytics.publish("promo_bar_clicked", eventData);
       });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector(".slideshow.flex");

  if (slideshow) {
    // Select all links inside the slideshow
    const slideLinks = slideshow.querySelectorAll("a");

    slideLinks.forEach(link => {
      link.addEventListener("click", (e) => {
        const parentSlide = link.closest("[id]"); // find slide with ID
        const slideId = parentSlide ? parentSlide.id : "unknown";

        const eventData = {
          slide_id: slideId,
          slide_text: link.innerText.trim(),
          slide_url: link.getAttribute("href")
        };

        console.log("slideshow clicked", eventData);

        // Publish to Shopify analytics pipeline
        Shopify.analytics.publish("slideshow_clicked", eventData);
      });
    });
  }
});

/*
document.addEventListener("DOMContentLoaded", () => {
  console.log('banner code loaded')
  const banner = document.querySelector("#template--18625900576825__slideshow_1");  
  if (banner) {    
    banner.addEventListener("click", () => {
      const eventData = {
        banner_name: banner.dataset.bannerName || "hero",
        banner_text: banner.innerText.trim(),
        banner_url: banner.getAttribute("href")
      };
      console.log('banner btn clicked', banner, eventData);
      
      // Publish Shopify custom event
      // document.dispatchEvent(new CustomEvent("click_host_banner", { detail: eventData }));

      // Publish to Shopify analytics pipeline
      
      Shopify.analytics.publish("click_host_banner", eventData);

    });
  }
});
*/

document.addEventListener("DOMContentLoaded", () => {
  const lpdPromoBar = document.querySelector(".announcement__text"); 

  if (lpdPromoBar) {
     const lpdPromoBarLink = lpdPromoBar.querySelectorAll("a");

     lpdPromoBarLink.forEach(link => {
    link.addEventListener("click", () => {
      const parentPromo = link.closest("[id]"); // find slide with ID
        const promoId = parentPromo ? parentPromo.id : "unknown";

      const eventData = {
        lpd_promo_id: promoId,
        lpd_promo_text: link.innerText.trim(),
        lpd_promo_url: link.getAttribute("href")
      };

      console.log("clicked promobar", eventData);

      // Publish to Shopify analytics pipeline
      Shopify.analytics.publish("clicked_promobar", eventData);
       });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const lpdSlideshow = document.querySelector(".slideshow.flex");

  if (lpdSlideshow) {
    // Select all links inside the slideshow
    const lpdSlideLinks = lpdSlideshow.querySelectorAll("a");

    lpdSlideLinks.forEach(link => {
      link.addEventListener("click", (e) => {
        const parentSlide = link.closest("[id]"); // find slide with ID
        const slideId = parentSlide ? parentSlide.id : "unknown";

        const eventData = {
          lpd_slide_id: slideId,
          lpd_slide_url: link.getAttribute("href")
        };

        console.log("clicked slideshow", eventData);

        // Publish to Shopify analytics pipeline
        Shopify.analytics.publish("clicked_slideshow", eventData);
      });
    });
  }
});